import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. El kit está diseñado especialmente para personas que comienzan desde cero y quieren un método claro y estructurado.'
}, {
  q: '¿Qué tipo de Tarot utiliza?',
  a: 'Las explicaciones están basadas principalmente en el Tarot Rider-Waite, el mazo más utilizado para aprender e interpretar en todo el mundo.'
}, {
  q: '¿Cómo recibiré el material?',
  a: 'Una vez confirmada tu compra recibirás un mail con el acceso inmediato para descargar todos los archivos digitales en formato PDF.'
}, {
  q: '¿Puedo acceder desde mi celular?',
  a: 'Sí. El material es totalmente compatible con celulares, tablets y computadoras. Podrás llevarlo siempre con vos.'
}, {
  q: '¿Los bonos están incluidos?',
  a: 'Sí. Los cinco bonos exclusivos forman parte de esta oferta especial de lanzamiento y se entregan sin costo adicional.'
}, {
  q: '¿Debo pagar una suscripción?',
  a: 'No. Es un único pago y el acceso es de por vida, incluyendo cualquier actualización futura del material.'
}, {
  q: '¿Puedo imprimir el contenido?',
  a: 'Sí. Todos los materiales están optimizados para que puedas imprimirlos si prefieres practicar con el papel en mano.'
}, {
  q: '¿Qué ocurre si no me gusta?',
  a: 'Estás protegido por nuestra garantía de satisfacción de 7 días. Si no es lo que esperabas, te devolvemos el 100% de tu dinero.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="px-5 relative overflow-hidden" data-id="element-105">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-106">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-petroleum mb-16 tracking-tight" data-id="element-107">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-108">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-3xl overflow-hidden transition-all shadow-premium border border-brand-petroleum/5" data-id="element-109">
              <button className="w-full px-8 py-8 text-left flex justify-between items-center focus:outline-none transition-colors hover:bg-brand-soft-cream/30" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-110">
                <span className="font-bold text-brand-petroleum text-base pr-8 leading-tight" data-id="element-111">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-brand-gold-warm flex-shrink-0" size={24} data-id="element-112" /> : <ChevronDown className="text-brand-medium-grey/30 flex-shrink-0" size={24} data-id="element-113" />}
              </button>
              {openIdx === idx && <div className="px-8 pb-8 text-brand-medium-grey text-base leading-relaxed border-t border-brand-petroleum/5" data-id="element-114">
                  <div className="pt-8 font-medium" data-id="element-115">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}